var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 88,
    viewBox: "0 0 140 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5662_7893)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_5662_7893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 33.9585L42.5457 30.6597L50.4548 30L51.0882 37.5927L56.1551 98.3349L8.70027 102.293L3 33.9585Z",
    fill: "#F4F3FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.7982,
    y1: 77.8913,
    x2: 44.412,
    y2: 75.0873,
    stroke: "#BDB4FE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.6344,
    y1: 63.9397,
    x2: 44.9285,
    y2: 60.9956,
    stroke: "#BDB4FE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.0975,
    y1: 70.9254,
    x2: 45.3916,
    y2: 67.9813,
    stroke: "#BDB4FE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.63928,
    y: 40.0228,
    width: 36,
    height: 18,
    transform: "rotate(-4.76839 7.63928 40.0228)",
    fill: "#D9D6FE"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dddd_5662_7893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.826 32.7245L97.5403 27.1208L89.6832 26L88.6073 33.5428L80 93.8851L127.142 100.61L136.826 32.7245Z",
    fill: "#F4F3FF"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 33.7306,
    y2: -1,
    transform: "matrix(-0.989979 -0.141212 -0.141212 0.989979 127.799 46.8295)",
    stroke: "#BDB4FE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 33.7306,
    y2: -1,
    transform: "matrix(-0.989979 -0.141212 -0.141212 0.989979 126.723 54.3721)",
    stroke: "#BDB4FE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 33.7306,
    y2: -1,
    transform: "matrix(-0.989979 -0.141212 -0.141212 0.989979 125.647 61.915)",
    stroke: "#BDB4FE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 33.7306,
    y2: -1,
    transform: "matrix(-0.989979 -0.141212 -0.141212 0.989979 124.571 69.4579)",
    stroke: "#BDB4FE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 33.7306,
    y2: -1,
    transform: "matrix(-0.989979 -0.141212 -0.141212 0.989979 123.495 77.0005)",
    stroke: "#BDB4FE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 33.7306,
    y2: -1,
    transform: "matrix(-0.989979 -0.141212 -0.141212 0.989979 122.419 84.5434)",
    stroke: "#BDB4FE",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dddd_5662_7893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 8H88.6667L93.3333 12.4444L98 16.8889V88H42V8Z",
    fill: "#F4F3FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.1662,
    y1: 24.7778,
    x2: 89.8329,
    y2: 24.7778,
    stroke: "#BDB4FE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.1662,
    y1: 33.6667,
    x2: 89.8329,
    y2: 33.6667,
    stroke: "#BDB4FE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.1662,
    y1: 42.5557,
    x2: 89.8329,
    y2: 42.5557,
    stroke: "#BDB4FE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.1662,
    y1: 51.4443,
    x2: 89.8329,
    y2: 51.4443,
    stroke: "#BDB4FE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.1662,
    y1: 60.3333,
    x2: 89.8329,
    y2: 60.3333,
    stroke: "#BDB4FE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.1662,
    y1: 69.2222,
    x2: 89.8329,
    y2: 69.2222,
    stroke: "#BDB4FE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6658 16.8889V8L97.9992 16.8889H88.6658Z",
    fill: "#BDB4FE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_5662_7893",
    x: -13,
    y: 27,
    width: 85.1551,
    height: 130.293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741176 0 0 0 0 0.705882 0 0 0 0 0.996078 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5662_7893"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741176 0 0 0 0 0.705882 0 0 0 0 0.996078 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5662_7893",
    result: "effect2_dropShadow_5662_7893"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741176 0 0 0 0 0.705882 0 0 0 0 0.996078 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5662_7893",
    result: "effect3_dropShadow_5662_7893"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741176 0 0 0 0 0.705882 0 0 0 0 0.996078 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_5662_7893",
    result: "effect4_dropShadow_5662_7893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_5662_7893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dddd_5662_7893",
    x: 64,
    y: 23,
    width: 88.8257,
    height: 132.61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741176 0 0 0 0 0.705882 0 0 0 0 0.996078 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5662_7893"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741176 0 0 0 0 0.705882 0 0 0 0 0.996078 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5662_7893",
    result: "effect2_dropShadow_5662_7893"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741176 0 0 0 0 0.705882 0 0 0 0 0.996078 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5662_7893",
    result: "effect3_dropShadow_5662_7893"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741176 0 0 0 0 0.705882 0 0 0 0 0.996078 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_5662_7893",
    result: "effect4_dropShadow_5662_7893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_5662_7893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dddd_5662_7893",
    x: 26,
    y: 5,
    width: 88,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.258824 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5662_7893"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.258824 0 0 0 0 1 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5662_7893",
    result: "effect2_dropShadow_5662_7893"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 23
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.258824 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5662_7893",
    result: "effect3_dropShadow_5662_7893"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 41
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.258824 0 0 0 0 1 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_5662_7893",
    result: "effect4_dropShadow_5662_7893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_5662_7893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5662_7893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame2.d57c1ff6a96beaf4f453c34ee95aeaa2.svg";
export { ForwardRef as ReactComponent };